"use strict";
var unitas = unitas || {};
const gallery = document.getElementById("js-hero-gallery");
const overlay = document.getElementById("js-hero-gallery-overlay");
const open = document.getElementById("js-hero-gallery-open");
const close = document.getElementById("js-hero-gallery-close");
unitas.herogallery =
  unitas.herogallery ||
  (function() {
    function init() {
      if (gallery && overlay && open) {
        var flkty;
        open.addEventListener("click", function() {
          unitas.darkoverlay.show();
          flkty = new Flickity(gallery, {
            // options
            cellAlign: "left",
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            wrapAround: true,
            draggable: false,
            fade: false,
            cellSelector: ".hero-gallery-item",
          });

          overlay.classList.add("hero-gallery-overlay--visible");
          gallery.classList.add("hero-gallery--visible");
        });

        if (close) {
          close.addEventListener("click", function() {
            unitas.darkoverlay.hide();
            overlay.classList.remove("hero-gallery-overlay--visible");

            setTimeout(() => {
              flkty.destroy();
              gallery.classList.remove("hero-gallery--visible");
            }, 900);
          });
          overlay.addEventListener("click", function(e) {
            let target = e.target;

            if (!target.classList.contains("flickity-button")) {
              unitas.darkoverlay.hide();
              overlay.classList.remove("hero-gallery-overlay--visible");

              setTimeout(() => {
                flkty.destroy();
                gallery.classList.remove("hero-gallery--visible");
              }, 900);
            }
          });
        }
      }
    }
    return {
      init: init,
    };
  })();
